export enum InfoTabs {
  imported = 'imported',
  exist = 'exist',
  error = 'error',
}
